export const PersonIconSvg = () => {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="21"
        height="21"
        viewBox="0 0 21 21"
        fill="none"
      >
        <path
          d="M10.5182 10.8258C9.60156 10.8258 8.81684 10.4995 8.16406 9.84668C7.51128 9.1939 7.1849 8.40918 7.1849 7.49251C7.1849 6.57585 7.51128 5.79112 8.16406 5.13835C8.81684 4.48557 9.60156 4.15918 10.5182 4.15918C11.4349 4.15918 12.2196 4.48557 12.8724 5.13835C13.5252 5.79112 13.8516 6.57585 13.8516 7.49251C13.8516 8.40918 13.5252 9.1939 12.8724 9.84668C12.2196 10.4995 11.4349 10.8258 10.5182 10.8258ZM3.85156 17.4925V15.1592C3.85156 14.687 3.97309 14.2529 4.21615 13.8571C4.4592 13.4613 4.78212 13.1592 5.1849 12.9508C6.04601 12.5203 6.92101 12.1974 7.8099 11.9821C8.69878 11.7668 9.60156 11.6592 10.5182 11.6592C11.4349 11.6592 12.3377 11.7668 13.2266 11.9821C14.1155 12.1974 14.9905 12.5203 15.8516 12.9508C16.2543 13.1592 16.5773 13.4613 16.8203 13.8571C17.0634 14.2529 17.1849 14.687 17.1849 15.1592V17.4925H3.85156ZM5.51823 15.8258H15.5182V15.1592C15.5182 15.0064 15.48 14.8675 15.4036 14.7425C15.3273 14.6175 15.2266 14.5203 15.1016 14.4508C14.3516 14.0758 13.5946 13.7946 12.8307 13.6071C12.0668 13.4196 11.296 13.3258 10.5182 13.3258C9.74045 13.3258 8.96962 13.4196 8.20573 13.6071C7.44184 13.7946 6.6849 14.0758 5.9349 14.4508C5.8099 14.5203 5.7092 14.6175 5.63281 14.7425C5.55642 14.8675 5.51823 15.0064 5.51823 15.1592V15.8258ZM10.5182 9.15918C10.9766 9.15918 11.3689 8.99599 11.6953 8.6696C12.0217 8.34321 12.1849 7.95085 12.1849 7.49251C12.1849 7.03418 12.0217 6.64182 11.6953 6.31543C11.3689 5.98904 10.9766 5.82585 10.5182 5.82585C10.0599 5.82585 9.66753 5.98904 9.34115 6.31543C9.01476 6.64182 8.85156 7.03418 8.85156 7.49251C8.85156 7.95085 9.01476 8.34321 9.34115 8.6696C9.66753 8.99599 10.0599 9.15918 10.5182 9.15918Z"
          fill="#212121"
        />
      </svg>
    </>
  );
};

export const ListIconSvg = () => {
  return (
    <>
      <svg
        width="21"
        height="21"
        viewBox="0 0 21 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7.83691 15.8887V14.222H17.8369V15.8887H7.83691ZM7.83691 10.8887V9.222H17.8369V10.8887H7.83691ZM7.83691 5.88867V4.22201H17.8369V5.88867H7.83691ZM4.50358 16.722C4.04525 16.722 3.65289 16.5588 3.3265 16.2324C3.00011 15.906 2.83691 15.5137 2.83691 15.0553C2.83691 14.597 3.00011 14.2046 3.3265 13.8783C3.65289 13.5519 4.04525 13.3887 4.50358 13.3887C4.96191 13.3887 5.35428 13.5519 5.68066 13.8783C6.00705 14.2046 6.17025 14.597 6.17025 15.0553C6.17025 15.5137 6.00705 15.906 5.68066 16.2324C5.35428 16.5588 4.96191 16.722 4.50358 16.722ZM4.50358 11.722C4.04525 11.722 3.65289 11.5588 3.3265 11.2324C3.00011 10.906 2.83691 10.5137 2.83691 10.0553C2.83691 9.597 3.00011 9.20464 3.3265 8.87825C3.65289 8.55187 4.04525 8.38867 4.50358 8.38867C4.96191 8.38867 5.35428 8.55187 5.68066 8.87825C6.00705 9.20464 6.17025 9.597 6.17025 10.0553C6.17025 10.5137 6.00705 10.906 5.68066 11.2324C5.35428 11.5588 4.96191 11.722 4.50358 11.722ZM4.50358 6.722C4.04525 6.722 3.65289 6.55881 3.3265 6.23242C3.00011 5.90603 2.83691 5.51367 2.83691 5.05534C2.83691 4.59701 3.00011 4.20464 3.3265 3.87826C3.65289 3.55187 4.04525 3.38867 4.50358 3.38867C4.96191 3.38867 5.35428 3.55187 5.68066 3.87826C6.00705 4.20464 6.17025 4.59701 6.17025 5.05534C6.17025 5.51367 6.00705 5.90603 5.68066 6.23242C5.35428 6.55881 4.96191 6.722 4.50358 6.722Z"
          fill="#212121"
        />
      </svg>
    </>
  );
};

export const DateIconSvg = () => {
  return (
    <>
      <svg
        width="21"
        height="21"
        viewBox="0 0 21 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M4.50358 18.3893C4.04525 18.3893 3.65289 18.2261 3.3265 17.8997C3.00011 17.5733 2.83691 17.181 2.83691 16.7227V5.05599C2.83691 4.59766 3.00011 4.2053 3.3265 3.87891C3.65289 3.55252 4.04525 3.38932 4.50358 3.38932H5.33691V1.72266H7.00358V3.38932H13.6702V1.72266H15.3369V3.38932H16.1702C16.6286 3.38932 17.0209 3.55252 17.3473 3.87891C17.6737 4.2053 17.8369 4.59766 17.8369 5.05599V16.7227C17.8369 17.181 17.6737 17.5733 17.3473 17.8997C17.0209 18.2261 16.6286 18.3893 16.1702 18.3893H4.50358ZM4.50358 16.7227H16.1702V8.38932H4.50358V16.7227ZM4.50358 6.72266H16.1702V5.05599H4.50358V6.72266ZM10.3369 11.7227C10.1008 11.7227 9.90289 11.6428 9.74316 11.4831C9.58344 11.3233 9.50358 11.1254 9.50358 10.8893C9.50358 10.6532 9.58344 10.4553 9.74316 10.2956C9.90289 10.1358 10.1008 10.056 10.3369 10.056C10.573 10.056 10.7709 10.1358 10.9307 10.2956C11.0904 10.4553 11.1702 10.6532 11.1702 10.8893C11.1702 11.1254 11.0904 11.3233 10.9307 11.4831C10.7709 11.6428 10.573 11.7227 10.3369 11.7227ZM7.00358 11.7227C6.76747 11.7227 6.56955 11.6428 6.40983 11.4831C6.25011 11.3233 6.17025 11.1254 6.17025 10.8893C6.17025 10.6532 6.25011 10.4553 6.40983 10.2956C6.56955 10.1358 6.76747 10.056 7.00358 10.056C7.23969 10.056 7.43761 10.1358 7.59733 10.2956C7.75705 10.4553 7.83691 10.6532 7.83691 10.8893C7.83691 11.1254 7.75705 11.3233 7.59733 11.4831C7.43761 11.6428 7.23969 11.7227 7.00358 11.7227ZM13.6702 11.7227C13.4341 11.7227 13.2362 11.6428 13.0765 11.4831C12.9168 11.3233 12.8369 11.1254 12.8369 10.8893C12.8369 10.6532 12.9168 10.4553 13.0765 10.2956C13.2362 10.1358 13.4341 10.056 13.6702 10.056C13.9064 10.056 14.1043 10.1358 14.264 10.2956C14.4237 10.4553 14.5036 10.6532 14.5036 10.8893C14.5036 11.1254 14.4237 11.3233 14.264 11.4831C14.1043 11.6428 13.9064 11.7227 13.6702 11.7227ZM10.3369 15.056C10.1008 15.056 9.90289 14.9761 9.74316 14.8164C9.58344 14.6567 9.50358 14.4588 9.50358 14.2227C9.50358 13.9865 9.58344 13.7886 9.74316 13.6289C9.90289 13.4692 10.1008 13.3893 10.3369 13.3893C10.573 13.3893 10.7709 13.4692 10.9307 13.6289C11.0904 13.7886 11.1702 13.9865 11.1702 14.2227C11.1702 14.4588 11.0904 14.6567 10.9307 14.8164C10.7709 14.9761 10.573 15.056 10.3369 15.056ZM7.00358 15.056C6.76747 15.056 6.56955 14.9761 6.40983 14.8164C6.25011 14.6567 6.17025 14.4588 6.17025 14.2227C6.17025 13.9865 6.25011 13.7886 6.40983 13.6289C6.56955 13.4692 6.76747 13.3893 7.00358 13.3893C7.23969 13.3893 7.43761 13.4692 7.59733 13.6289C7.75705 13.7886 7.83691 13.9865 7.83691 14.2227C7.83691 14.4588 7.75705 14.6567 7.59733 14.8164C7.43761 14.9761 7.23969 15.056 7.00358 15.056ZM13.6702 15.056C13.4341 15.056 13.2362 14.9761 13.0765 14.8164C12.9168 14.6567 12.8369 14.4588 12.8369 14.2227C12.8369 13.9865 12.9168 13.7886 13.0765 13.6289C13.2362 13.4692 13.4341 13.3893 13.6702 13.3893C13.9064 13.3893 14.1043 13.4692 14.264 13.6289C14.4237 13.7886 14.5036 13.9865 14.5036 14.2227C14.5036 14.4588 14.4237 14.6567 14.264 14.8164C14.1043 14.9761 13.9064 15.056 13.6702 15.056Z"
          fill="#212121"
        />
      </svg>
    </>
  );
};

export const CircleIcon = () => {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="12"
        height="12"
        viewBox="0 0 12 12"
        fill="none"
      >
        <circle
          cx="6.4375"
          cy="5.76172"
          r="4.96111"
          stroke="#25471F"
          stroke-width="1.07778"
        />
        <circle cx="6.4375" cy="5.76172" r="2.75" fill="#25471F" />
      </svg>
    </>
  );
};

export const ToastsuccessIocon = () => {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="23"
        height="23"
        viewBox="0 0 23 23"
        fill="none"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M11.3027 0.625488C5.22773 0.625488 0.302734 5.55049 0.302734 11.6255C0.302734 17.7005 5.22773 22.6255 11.3027 22.6255C17.3777 22.6255 22.3027 17.7005 22.3027 11.6255C22.3027 5.55049 17.3777 0.625488 11.3027 0.625488ZM16.0707 9.76549C16.1585 9.66513 16.2254 9.54823 16.2673 9.42166C16.3093 9.29509 16.3255 9.1614 16.315 9.02847C16.3045 8.89554 16.2676 8.76605 16.2063 8.64762C16.145 8.52918 16.0607 8.42419 15.9583 8.33883C15.8558 8.25347 15.7374 8.18945 15.6098 8.15055C15.4823 8.11165 15.3483 8.09865 15.2156 8.11232C15.083 8.12598 14.9544 8.16604 14.8375 8.23012C14.7205 8.29421 14.6176 8.38103 14.5347 8.48549L10.2347 13.6445L8.00973 11.4185C7.82113 11.2363 7.56853 11.1355 7.30633 11.1378C7.04414 11.1401 6.79332 11.2453 6.60792 11.4307C6.42251 11.6161 6.31734 11.8669 6.31506 12.1291C6.31278 12.3913 6.41358 12.6439 6.59573 12.8325L9.59573 15.8325C9.69399 15.9307 9.81163 16.0073 9.94115 16.0575C10.0707 16.1078 10.2092 16.1304 10.348 16.1241C10.4868 16.1178 10.6227 16.0827 10.7471 16.0209C10.8716 15.9592 10.9818 15.8722 11.0707 15.7655L16.0707 9.76549Z"
          fill="#58A84A"
        />
      </svg>
    </>
  );
};

export const EditIcon = () => {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        height="24px"
        viewBox="0 -960 960 960"
        width="24px"
        fill="#5f6368"
      >
        <path d="M200-200h57l391-391-57-57-391 391v57Zm-80 80v-170l528-527q12-11 26.5-17t30.5-6q16 0 31 6t26 18l55 56q12 11 17.5 26t5.5 30q0 16-5.5 30.5T817-647L290-120H120Zm640-584-56-56 56 56Zm-141 85-28-29 57 57-29-28Z" />
      </svg>
    </>
  );
};

export const DeleteIcon = () => {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        height="24px"
        viewBox="0 -960 960 960"
        width="24px"
        fill="#5f6368"
      >
        <path d="M280-120q-33 0-56.5-23.5T200-200v-520h-40v-80h200v-40h240v40h200v80h-40v520q0 33-23.5 56.5T680-120H280Zm400-600H280v520h400v-520ZM360-280h80v-360h-80v360Zm160 0h80v-360h-80v360ZM280-720v520-520Z" />
      </svg>
    </>
  );
};

export const DownloadIcon = () => {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        height="24px"
        viewBox="0 -960 960 960"
        width="24px"
        fill="#5f6368"
      >
        <path d="M480-320 280-520l56-58 104 104v-326h80v326l104-104 56 58-200 200ZM240-160q-33 0-56.5-23.5T160-240v-120h80v120h480v-120h80v120q0 33-23.5 56.5T720-160H240Z" />
      </svg>
    </>
  );
};

export const DashboardIcon = () => {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
      >
        <path
          d="M15.8333 4.16667V5.83333H12.5V4.16667H15.8333ZM7.5 4.16667V9.16667H4.16667V4.16667H7.5ZM15.8333 10.8333V15.8333H12.5V10.8333H15.8333ZM7.5 14.1667V15.8333H4.16667V14.1667H7.5ZM17.5 2.5H10.8333V7.5H17.5V2.5ZM9.16667 2.5H2.5V10.8333H9.16667V2.5ZM17.5 9.16667H10.8333V17.5H17.5V9.16667ZM9.16667 12.5H2.5V17.5H9.16667V12.5Z"
          fill="black"
        />
      </svg>
    </>
  );
};

export const CustomerIcon = () => {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
      >
        <path
          d="M9.99992 9.99998C9.08325 9.99998 8.29853 9.67359 7.64575 9.02081C6.99297 8.36803 6.66658 7.58331 6.66658 6.66665C6.66658 5.74998 6.99297 4.96526 7.64575 4.31248C8.29853 3.6597 9.08325 3.33331 9.99992 3.33331C10.9166 3.33331 11.7013 3.6597 12.3541 4.31248C13.0069 4.96526 13.3333 5.74998 13.3333 6.66665C13.3333 7.58331 13.0069 8.36803 12.3541 9.02081C11.7013 9.67359 10.9166 9.99998 9.99992 9.99998ZM3.33325 16.6666V14.3333C3.33325 13.8611 3.45478 13.4271 3.69784 13.0312C3.94089 12.6354 4.26381 12.3333 4.66659 12.125C5.5277 11.6944 6.4027 11.3715 7.29158 11.1562C8.18047 10.941 9.08325 10.8333 9.99992 10.8333C10.9166 10.8333 11.8194 10.941 12.7083 11.1562C13.5971 11.3715 14.4721 11.6944 15.3333 12.125C15.736 12.3333 16.0589 12.6354 16.302 13.0312C16.5451 13.4271 16.6666 13.8611 16.6666 14.3333V16.6666H3.33325ZM4.99992 15H14.9999V14.3333C14.9999 14.1805 14.9617 14.0416 14.8853 13.9166C14.8089 13.7916 14.7083 13.6944 14.5833 13.625C13.8333 13.25 13.0763 12.9687 12.3124 12.7812C11.5485 12.5937 10.7777 12.5 9.99992 12.5C9.22214 12.5 8.45131 12.5937 7.68742 12.7812C6.92353 12.9687 6.16659 13.25 5.41659 13.625C5.29159 13.6944 5.19089 13.7916 5.1145 13.9166C5.03811 14.0416 4.99992 14.1805 4.99992 14.3333V15ZM9.99992 8.33331C10.4583 8.33331 10.8506 8.17012 11.177 7.84373C11.5034 7.51734 11.6666 7.12498 11.6666 6.66665C11.6666 6.20831 11.5034 5.81595 11.177 5.48956C10.8506 5.16317 10.4583 4.99998 9.99992 4.99998C9.54158 4.99998 9.14922 5.16317 8.82283 5.48956C8.49645 5.81595 8.33325 6.20831 8.33325 6.66665C8.33325 7.12498 8.49645 7.51734 8.82283 7.84373C9.14922 8.17012 9.54158 8.33331 9.99992 8.33331Z"
          fill="#212121"
        />
      </svg>
    </>
  );
};

export const ProjectIcon = () => {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="21"
        viewBox="0 0 20 21"
        fill="none"
      >
        <path
          d="M13.3333 12.139C12.6389 12.139 12.0486 11.8959 11.5625 11.4098C11.0764 10.9237 10.8333 10.3334 10.8333 9.639C10.8333 8.94455 11.0764 8.35427 11.5625 7.86816C12.0486 7.38205 12.6389 7.139 13.3333 7.139C14.0278 7.139 14.6181 7.38205 15.1042 7.86816C15.5903 8.35427 15.8333 8.94455 15.8333 9.639C15.8333 10.3334 15.5903 10.9237 15.1042 11.4098C14.6181 11.8959 14.0278 12.139 13.3333 12.139ZM8.33333 17.139V15.5557C8.33333 15.264 8.40278 14.9862 8.54167 14.7223C8.68056 14.4584 8.875 14.2501 9.125 14.0973C9.75 13.7223 10.4132 13.4411 11.1146 13.2536C11.816 13.0661 12.5556 12.9723 13.3333 12.9723C14.1111 12.9723 14.8507 13.0661 15.5521 13.2536C16.2535 13.4411 16.9167 13.7223 17.5417 14.0973C17.7917 14.2501 17.9861 14.4584 18.125 14.7223C18.2639 14.9862 18.3333 15.264 18.3333 15.5557V17.139H8.33333ZM10.125 15.4723H16.5417C16.0556 15.1946 15.5417 14.9862 15 14.8473C14.4583 14.7084 13.9028 14.639 13.3333 14.639C12.7639 14.639 12.2083 14.7084 11.6667 14.8473C11.125 14.9862 10.6111 15.1946 10.125 15.4723ZM13.3333 10.4723C13.5694 10.4723 13.7674 10.3925 13.9271 10.2327C14.0868 10.073 14.1667 9.87511 14.1667 9.639C14.1667 9.40289 14.0868 9.20497 13.9271 9.04525C13.7674 8.88552 13.5694 8.80566 13.3333 8.80566C13.0972 8.80566 12.8993 8.88552 12.7396 9.04525C12.5799 9.20497 12.5 9.40289 12.5 9.639C12.5 9.87511 12.5799 10.073 12.7396 10.2327C12.8993 10.3925 13.0972 10.4723 13.3333 10.4723ZM2.5 12.139V10.4723H9.16667V12.139H2.5ZM2.5 5.47233V3.80566H12.5V5.47233H2.5ZM9.25 8.80566H2.5V7.139H10C9.80556 7.37511 9.64931 7.63205 9.53125 7.90983C9.41319 8.18761 9.31944 8.48622 9.25 8.80566Z"
          fill="#212121"
        />
      </svg>
    </>
  );
};

export const BillingIcon = () => {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="21"
        viewBox="0 0 20 21"
        fill="none"
      >
        <path
          d="M5 18.8063C4.30556 18.8063 3.71528 18.5633 3.22917 18.0771C2.74306 17.591 2.5 17.0008 2.5 16.3063V13.8063H5V2.13965L6.25 3.38965L7.5 2.13965L8.75 3.38965L10 2.13965L11.25 3.38965L12.5 2.13965L13.75 3.38965L15 2.13965L16.25 3.38965L17.5 2.13965V16.3063C17.5 17.0008 17.2569 17.591 16.7708 18.0771C16.2847 18.5633 15.6944 18.8063 15 18.8063H5ZM15 17.1396C15.2361 17.1396 15.434 17.0598 15.5938 16.9001C15.7535 16.7403 15.8333 16.5424 15.8333 16.3063V4.63965H6.66667V13.8063H14.1667V16.3063C14.1667 16.5424 14.2465 16.7403 14.4062 16.9001C14.566 17.0598 14.7639 17.1396 15 17.1396ZM7.5 7.97298V6.30631H12.5V7.97298H7.5ZM7.5 10.473V8.80631H12.5V10.473H7.5ZM14.1667 7.97298C13.9306 7.97298 13.7326 7.89312 13.5729 7.7334C13.4132 7.57368 13.3333 7.37576 13.3333 7.13965C13.3333 6.90354 13.4132 6.70562 13.5729 6.5459C13.7326 6.38618 13.9306 6.30631 14.1667 6.30631C14.4028 6.30631 14.6007 6.38618 14.7604 6.5459C14.9201 6.70562 15 6.90354 15 7.13965C15 7.37576 14.9201 7.57368 14.7604 7.7334C14.6007 7.89312 14.4028 7.97298 14.1667 7.97298ZM14.1667 10.473C13.9306 10.473 13.7326 10.3931 13.5729 10.2334C13.4132 10.0737 13.3333 9.87576 13.3333 9.63965C13.3333 9.40354 13.4132 9.20562 13.5729 9.0459C13.7326 8.88618 13.9306 8.80631 14.1667 8.80631C14.4028 8.80631 14.6007 8.88618 14.7604 9.0459C14.9201 9.20562 15 9.40354 15 9.63965C15 9.87576 14.9201 10.0737 14.7604 10.2334C14.6007 10.3931 14.4028 10.473 14.1667 10.473ZM5 17.1396H12.5V15.473H4.16667V16.3063C4.16667 16.5424 4.24653 16.7403 4.40625 16.9001C4.56597 17.0598 4.76389 17.1396 5 17.1396Z"
          fill="#212121"
        />
      </svg>
    </>
  );
};

export const InvoiceIcon = () => {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="21"
        viewBox="0 0 20 21"
        fill="none"
      >
        <path
          d="M6.66683 15.473H13.3335V13.8063H6.66683V15.473ZM6.66683 12.1396H13.3335V10.473H6.66683V12.1396ZM5.00016 18.8063C4.54183 18.8063 4.14947 18.6431 3.82308 18.3167C3.49669 17.9903 3.3335 17.598 3.3335 17.1396V3.80631C3.3335 3.34798 3.49669 2.95562 3.82308 2.62923C4.14947 2.30284 4.54183 2.13965 5.00016 2.13965H11.6668L16.6668 7.13965V17.1396C16.6668 17.598 16.5036 17.9903 16.1772 18.3167C15.8509 18.6431 15.4585 18.8063 15.0002 18.8063H5.00016ZM10.8335 7.97298V3.80631H5.00016V17.1396H15.0002V7.97298H10.8335Z"
          fill="#212121"
        />
      </svg>
    </>
  );
};

export const ManageUserIcon = () => {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="21"
        viewBox="0 0 20 21"
        fill="none"
      >
        <path
          d="M8.33317 10.4723C7.4165 10.4723 6.63178 10.1459 5.979 9.49316C5.32623 8.84039 4.99984 8.05566 4.99984 7.139C4.99984 6.22233 5.32623 5.43761 5.979 4.78483C6.63178 4.13205 7.4165 3.80566 8.33317 3.80566C9.24984 3.80566 10.0346 4.13205 10.6873 4.78483C11.3401 5.43761 11.6665 6.22233 11.6665 7.139C11.6665 8.05566 11.3401 8.84039 10.6873 9.49316C10.0346 10.1459 9.24984 10.4723 8.33317 10.4723ZM1.6665 17.139V14.8057C1.6665 14.3473 1.78456 13.9168 2.02067 13.514C2.25678 13.1112 2.58317 12.8057 2.99984 12.5973C3.70817 12.2362 4.50678 11.9307 5.39567 11.6807C6.28456 11.4307 7.26373 11.3057 8.33317 11.3057H8.62484C8.70817 11.3057 8.7915 11.3196 8.87484 11.3473C8.76373 11.5973 8.66998 11.8577 8.59359 12.1286C8.5172 12.3994 8.45817 12.6807 8.4165 12.9723H8.33317C7.34706 12.9723 6.46164 13.0973 5.67692 13.3473C4.8922 13.5973 4.24984 13.8473 3.74984 14.0973C3.62484 14.1668 3.52414 14.264 3.44775 14.389C3.37137 14.514 3.33317 14.6529 3.33317 14.8057V15.4723H8.58317C8.6665 15.764 8.77762 16.0522 8.9165 16.3369C9.05539 16.6216 9.20817 16.889 9.37484 17.139H1.6665ZM13.3332 17.9723L13.0832 16.7223C12.9165 16.6529 12.7603 16.58 12.6144 16.5036C12.4686 16.4272 12.3193 16.3334 12.1665 16.2223L10.9582 16.5973L10.1248 15.1807L11.0832 14.3473C11.0554 14.1529 11.0415 13.9723 11.0415 13.8057C11.0415 13.639 11.0554 13.4584 11.0832 13.264L10.1248 12.4307L10.9582 11.014L12.1665 11.389C12.3193 11.2779 12.4686 11.1841 12.6144 11.1077C12.7603 11.0314 12.9165 10.9584 13.0832 10.889L13.3332 9.639H14.9998L15.2498 10.889C15.4165 10.9584 15.5728 11.0348 15.7186 11.1182C15.8644 11.2015 16.0137 11.3057 16.1665 11.4307L17.3748 11.014L18.2082 12.4723L17.2498 13.3057C17.2776 13.4723 17.2915 13.6459 17.2915 13.8265C17.2915 14.0071 17.2776 14.1807 17.2498 14.3473L18.2082 15.1807L17.3748 16.5973L16.1665 16.2223C16.0137 16.3334 15.8644 16.4272 15.7186 16.5036C15.5728 16.58 15.4165 16.6529 15.2498 16.7223L14.9998 17.9723H13.3332ZM14.1665 15.4723C14.6248 15.4723 15.0172 15.3091 15.3436 14.9827C15.67 14.6564 15.8332 14.264 15.8332 13.8057C15.8332 13.3473 15.67 12.955 15.3436 12.6286C15.0172 12.3022 14.6248 12.139 14.1665 12.139C13.7082 12.139 13.3158 12.3022 12.9894 12.6286C12.663 12.955 12.4998 13.3473 12.4998 13.8057C12.4998 14.264 12.663 14.6564 12.9894 14.9827C13.3158 15.3091 13.7082 15.4723 14.1665 15.4723ZM8.33317 8.80566C8.7915 8.80566 9.18387 8.64247 9.51025 8.31608C9.83664 7.98969 9.99984 7.59733 9.99984 7.139C9.99984 6.68066 9.83664 6.2883 9.51025 5.96191C9.18387 5.63553 8.7915 5.47233 8.33317 5.47233C7.87484 5.47233 7.48248 5.63553 7.15609 5.96191C6.8297 6.2883 6.6665 6.68066 6.6665 7.139C6.6665 7.59733 6.8297 7.98969 7.15609 8.31608C7.48248 8.64247 7.87484 8.80566 8.33317 8.80566Z"
          fill="#212121"
        />
      </svg>
    </>
  );
};

export const LogoutIcon = () => {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
      >
        <path
          d="M14.1665 5.83333L12.9915 7.00833L15.1415 9.16667H6.6665V10.8333H15.1415L12.9915 12.9833L14.1665 14.1667L18.3332 10L14.1665 5.83333ZM3.33317 4.16667H9.99984V2.5H3.33317C2.4165 2.5 1.6665 3.25 1.6665 4.16667V15.8333C1.6665 16.75 2.4165 17.5 3.33317 17.5H9.99984V15.8333H3.33317V4.16667Z"
          fill="black"
        />
      </svg>
    </>
  );
};

export const BrokerCloseIcon = () => {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="11"
        height="10"
        viewBox="0 0 11 10"
        fill="none"
      >
        <path
          d="M7.06225 6.25L4.5625 3.75M4.56277 6.25L7.0625 3.75"
          stroke="#6941C6"
          stroke-width="0.8"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M9.97884 5.00065C9.97884 2.69946 8.11334 0.833984 5.81217 0.833984C3.51099 0.833984 1.64551 2.69946 1.64551 5.00065C1.64551 7.30182 3.51099 9.16732 5.81217 9.16732C8.11334 9.16732 9.97884 7.30182 9.97884 5.00065Z"
          stroke="#6941C6"
          stroke-width="0.8"
        />
      </svg>
    </>
  );
};

export const AdminCloseIcon = () => {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="12"
        height="10"
        viewBox="0 0 12 10"
        fill="none"
      >
        <path
          d="M7.21264 6.25L4.71289 3.75M4.71316 6.25L7.21289 3.75"
          stroke="#175CD3"
          stroke-width="0.8"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M10.1292 5.00065C10.1292 2.69946 8.26373 0.833984 5.96257 0.833984C3.66138 0.833984 1.7959 2.69946 1.7959 5.00065C1.7959 7.30182 3.66138 9.16732 5.96257 9.16732C8.26373 9.16732 10.1292 7.30182 10.1292 5.00065Z"
          stroke="#175CD3"
          stroke-width="0.8"
        />
      </svg>
    </>
  );
};

export const UploadDeleteIcon = () => {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="14"
        height="15"
        viewBox="0 0 14 15"
        fill="none"
      >
        <path
          d="M3 15C2.54167 15 2.14931 14.8368 1.82292 14.5104C1.49653 14.184 1.33333 13.7917 1.33333 13.3333V2.5H0.5V0.833333H4.66667V0H9.66667V0.833333H13.8333V2.5H13V13.3333C13 13.7917 12.8368 14.184 12.5104 14.5104C12.184 14.8368 11.7917 15 11.3333 15H3ZM4.66667 11.6667H6.33333V4.16667H4.66667V11.6667ZM8 11.6667H9.66667V4.16667H8V11.6667Z"
          fill="#DF0000"
        />
      </svg>
    </>
  );
};
